import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./Logo.svg";
import SideNav from "./SideNav";

const NavBar = (props) => {
  const [showSideNav, setShowSideNav] = useState(false);
  return (
    <nav className="flex flex-row justify-between w-screen px-4 py-2">
     <Link to="/discover"><img className="h-10" src={logo} alt="Sound Basket" /></Link>
     <button onClick={() => setShowSideNav(true)}>      
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 9h16.5m-16.5 6.75h16.5"
          />
        </svg>      
      </button>
      {showSideNav && <SideNav accessToken={props.accessToken} logUserOut={props.logUserOut} setShowSideNav={setShowSideNav} />}
    </nav>
  );
};

export default NavBar;
